export default "__VITE_ASSET__61606883__"